import { useContext, useEffect, useRef, useState } from "react";
import { SettlementCustomerOpeningBalancesDto } from "../../../../dtos/documents/SettlementCustomerOpeningBalances/SettlementCustomerOpeningBalancesDto";
import { FormProvider, useForm } from "react-hook-form";
import { NewDocumentModalViewContext } from "../../../Shared/NewDocumentModalView";
import { DocumentModalViewHeader } from "../../../Shared/DocumentModalViewHeader";
import { SettlementCustomerOpeningBalancesModel } from "../../../../models/Documents/SettlementCustomerOpeningBalances/SettlementCustomerOpeningBalancesModel";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { importFromExcel } from "../../../../helpers/SaveObjectToExcel";
import { AppEntities } from "../../../../config/entities";
import { saveObjectToExcel } from "../../../../helpers/SaveObjectToExcel";
import { SettlementCustomerOpeningBalancesDetailMain } from "./SettlementCustomerOpeningBalancesDetailMain";
import { SettlementCustomerOpeningBalancesDetailSettlement } from "./SettlementCustomerOpeningBalancesDetailSettlement";
import { SettlementCustomerOpeningBalancesDetailFooter } from "./SettlementCustomerOpeningBalancesDetailFooter";

interface IProps {
  model: SettlementCustomerOpeningBalancesDto | null;
  modelUpdatedEvent: (newModel: SettlementCustomerOpeningBalancesDto) => void;
}

export const SettlementCustomerOpeningBalancesDetails = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<SettlementCustomerOpeningBalancesModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Settlement Customer Opening Balances");

  const watchProducts = watch("settlements");

  useEffect(() => {
    // console.log(model);
    register("settlements");
    if (model) {
      setValue("baseDocumentAtId", model.baseDocumentAtId);
      setValue("documentDate", model.documentDate);
      setValue("createdDate", model.createdDate);
      setValue("companyId", model.companyId);
      setValue("pendingChanges", model.pendingChanges);
      setValue("status", model.status);
      setValue("comment", model.comment);
      setValue("settlements", model.settlements);
    }
  }, [model]);

  const handleFormSubmitLocal = async (action: DocumentSaveActionType, data: SettlementCustomerOpeningBalancesModel) => {
    await handleFormSubmit(action, data, model, saveHandler, postHandler);
  };

  if (!model) {
    return <>{/* <StockTakingsDetailSkeleton /> */}</>;
  }

  const exportToExcel = () => {
    const data = {
      ...model
    };
    const documentInfo = {
      title: AppEntities.SettlementCustomerOpeningBalances.title,
      number: model.documentNumber,
      date: model.documentDate
    };
    saveObjectToExcel(data, documentInfo);
  };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      reset(data);
    });
  };
  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Products"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        <DocumentModalViewHeader
          onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))}
          onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))}
          onClose={closeHandler}
          onCancel={cancelHandler}
          handleUploadFile={handleUploadFile}
          exportToExcel={exportToExcel}
          fileName={fileName}
          setFileName={setFileName}
        />

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <SettlementCustomerOpeningBalancesDetailMain />
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <SettlementCustomerOpeningBalancesDetailSettlement />
        </NFTabContainer>
      </div>
      <SettlementCustomerOpeningBalancesDetailFooter/>
    </FormProvider>
  );
};
